import { ApiService } from "Services/ApiService";
import { Academic } from "Types/Admin/AdminAcademicType";
import { ResultsDTO } from "Types/ResultsDTO";

export const academicApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getAllAcademics: builder.query<Academic[], { plant: string; search?: string }>({
      query: ({ plant, search }) => ({
        url: "academic/all",
        params: { plant, ...(search && { search }) },
      }),
      transformResponse: (res: ResultsDTO<Academic[]>) => res.results ?? [],
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "Academic" as const, id })),
              { type: "Academic", id: "LIST" },
            ]
          : [{ type: "Academic", id: "LIST" }],
    }),
    getAcademicById: builder.query<Academic, { id: number; plant: string }>({
      query: ({ id, plant }) => ({
        url: "academic",
        params: { id, plant },
      }),
      transformResponse: (res: ResultsDTO<Academic>) => res.results,
      providesTags: (result, error, { id }) => [{ type: "Academic", id }],
    }),
    addAcademic: builder.mutation<ResultsDTO<Academic>, { plant: string; data: { academic: string; crBy: string; isActive: string } }>({
      query: ({ plant, data }) => ({
        url: `academic/add`,
        method: "POST",
        params: { plant },
        body: data,
      }),
      invalidatesTags: [{ type: "Academic", id: "LIST" }],
    }),
    updateAcademic: builder.mutation<ResultsDTO, { id: number; plant: string; data: { academic: string; isActive: string; upBy: string } }>({
      query: ({ id, plant, data }) => ({
        url: `academic/update`,
        method: "PUT",
        params: { id, plant },
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "Academic", id }],
    }),
    deleteAcademic: builder.mutation<ResultsDTO, { id: number; plant: string }>({
      query: ({ id, plant }) => ({
        url: `academic/delete`,
        method: "DELETE",
        params: { id, plant },
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "Academic", id }],
    }),
    bulkDeleteAcademics: builder.mutation<ResultsDTO, { ids: number[]; plant: string }>({
      query: ({ ids, plant }) => ({
        url: `/academic/bulk-delete`,
        method: "DELETE",
        params: { ids, plant },
      }),
      invalidatesTags: [{ type: "Academic", id: "LIST" }],
    }),
  }),
});

export const {
  useGetAllAcademicsQuery,
  useLazyGetAcademicByIdQuery,
  useAddAcademicMutation,
  useUpdateAcademicMutation,
  useDeleteAcademicMutation,
  useBulkDeleteAcademicsMutation,
} = academicApiSlice;
